import { SpeakerManagementService } from '@src/services/SpeakerManagementService';
import { useDatoClient } from '@src/stores-v2/StoreContext';
import { useMemo } from 'react';

export function useSpeakerManagementService(): SpeakerManagementService {
  const datoClientStore = useDatoClient();
  return useMemo(
    () =>
      new SpeakerManagementService({
        speakerRepository: datoClientStore.speakerRepository,
      }),
    [datoClientStore.speakerRepository],
  );
}
